// extracted by mini-css-extract-plugin
export var black = "_3k-6";
export var brand = "_3k-1";
export var ddefault = "_3k-0";
export var error = "_3k-3";
export var gray = "_3k-2";
export var highContrast = "_3k-8";
export var outline = "_3k-7";
export var success = "_3k-5";
export var warning = "_3k-4";